import React, { useState } from 'react';
import { get } from '../../Services/http';
import { translate } from '../../Services/translation';

const VatToggle = ({ toggle }) => {
  const [vat, setVat] = useState(toggle);

  const handleClick = () => {
    setVat(!vat);

    get('/api/v1/togglevat').then(() => window.location.reload());
  };

  const renderButton = (text) => {
    let isActive = vat;

    if (text === 'product.vattext.included') isActive = !vat;

    return (
      <button
        key={text}
        id={text}
        className={`product-detail__vat-toggle--${isActive ? '' : 'in'}active`}
        disabled={isActive}
        onClick={handleClick}
      >
        {translate(text)}
      </button>
    );
  };

  const renderButtons = () => ['product.vattext.included', 'product.vattext.excluded'].map((i) => renderButton(i));

  return <>{renderButtons()}</>;
};

export default VatToggle;
